// create a dictionary of the runner elements, to be used for ordering the runners
export const runnersDict = { HOME: null, AWAY: null, NA: null };
